import { PageContainer, Skeleton, Surface } from "@/components/ui"

export function LoadingPage() {
  return (
    <Surface surface="page" className="fixed top-0 h-screen w-full max-w-shell mx-auto overflow-y-hidden">
      <div className="relative aspect-wide w-full overflow-hidden">
        <Skeleton shape="block" className="absolute inset-x-0 -top-4 bottom-0" />
      </div>
      <Infos />
      <Surface surface="card" className="rounded-t-card">
        <PageContainer className="py-4">
          {[0, 1, 2, 3].map(v => (
            <Skeleton key={v} shape="block" className="my-4 h-44 w-full" />
          ))}
        </PageContainer>
      </Surface>
    </Surface>
  )
}

function Infos() {
  return (
    <PageContainer paint>
      <div className="-mt-14 h-28 w-28 rounded-full border border-border">
        <Skeleton shape="circle" className="h-full w-full" />
      </div>
      <div className="flex justify-between pt-6 pb-2">
        <Skeleton shape="block" className="h-8 w-52" />
        <Skeleton shape="block" className="h-8 w-20" />
      </div>
      <div className="flex flex-col gap-1 pt-2">
        <Skeleton shape="block" className="h-6 w-full" />
        <div className="grid grid-cols-3 gap-x-1 gap-y-1">
          <Skeleton shape="block" className="col-span-1 h-6" />
          <Skeleton shape="block" className="col-span-1 h-6" />
          <Skeleton shape="block" className="col-span-1 h-6" />
        </div>
      </div>
      <Skeleton shape="block" className="my-6 h-12 w-full" />
    </PageContainer>
  )
}
